(function() { window.GUID_480f95f4_698f_450c_a066_ff2d8f2d55f0 = { getGuid: function() { return "480f95f4-698f-450c-a066-ff2d8f2d55f0"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class LineChart {
            get isMobile() {
                return window.innerWidth < 600;
            }
            get chartInnerHeight() {
                if (this.mode === "static") {
                    return this.isMobile
                        ? this.chartInnerWidth * 1
                        : this.chartInnerWidth * 0.55;
                }
                else {
                    return 400;
                }
            }
            get chartMarginBottom() {
                return this.fontSizeX * 7;
            }
            get chartMarginLeft() {
                return this.fontSizeY * 3;
            }
            constructor(id, data, valueFormatter, forcedMin, forcedMax, mode = "static", 
            /**
                          If false, no area will be drawn.
                          If true or undefined, an area will be drawn for each line.
                          If an array of strings, an area will be drawn only for those symbols.
                        */
            area, useDivergentPalette) {
                this.id = id;
                this.data = data;
                this.valueFormatter = valueFormatter;
                this.forcedMin = forcedMin;
                this.forcedMax = forcedMax;
                this.mode = mode;
                this.area = area;
                this.useDivergentPalette = useDivergentPalette;
                this.state = "unready";
                this.rootElement = null;
                this.containerElement = null;
                this.innerContainerElement = null;
                this.innerChartContainerElement = null;
                this.innerChartElement = null;
                this.series = [];
                this.datapointsBySymbol = {};
                this.datapointsByDate = {};
                this.flatData = [];
                this.yScale = null;
                this.statFieldIds = [];
                this.domainLineColor = "hsl(0, 0%, 50%)";
                this.svg = null;
                this.xScale = null;
                this.anyNegativeValues = false;
                this.serie = null;
                this.symbols = [];
                this.tooltipV2 = null;
                this.svgOverlay = null;
                this.chartOverlayElement = null;
                this.chartInnerWidth = 0;
                this.chartMarginRight = 8;
                this.chartMarginTop = 8;
                this.textColorX = "rgba(255, 255, 255, 0.5)";
                this.textColorY = "rgba(255, 255, 255, 0.7)";
                this.palette = [];
                if (!this.valueFormatter) {
                    this.valueFormatter = (value) => {
                        return value.toString();
                    };
                }
                let bodyFontSize = window
                    .getComputedStyle(document.body)
                    .getPropertyValue("font-size");
                if (bodyFontSize && bodyFontSize.endsWith("px")) {
                    bodyFontSize = bodyFontSize.slice(0, -2);
                }
                if (bodyFontSize) {
                    const fontSizeXMultiplier = this.mode === "static" ? 0.7 : 0.9;
                    const fontSizeYMultiplier = this.mode === "static" ? 0.8 : 1;
                    const fontSize = Number(bodyFontSize);
                    this.fontSizeX = fontSize * fontSizeXMultiplier;
                    this.fontSizeY = fontSize * fontSizeYMultiplier;
                }
                else {
                    this.fontSizeX = 12;
                    this.fontSizeY = 16;
                }
                if (this.mode === "static") {
                    this.chartInnerWidth = this.isMobile ? 400 : 600;
                    this.strokeWidth = 2;
                    this.pointRadius = 3;
                }
                else {
                    this.strokeWidth = 3;
                    this.pointRadius = 4;
                }
            }
            init() {
                return __awaiter(this, void 0, void 0, function* () {
                    yield this.initialize();
                });
            }
            initialize() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        this.setData();
                        this.setPalette();
                        this.createHTML();
                        yield this.setChartDimensions();
                        this.render()
                            .then(() => {
                            this.bindEvents();
                            this.setState("ready");
                        })
                            .catch((error) => {
                            console.error(error);
                            this.setState("error");
                        });
                    }
                    catch (error) {
                        console.error(error);
                        this.setState("error");
                    }
                });
            }
            bindEvents() {
                $(this.containerElement).offon("click.legendItemClicked", ".chart__legend-item", this.handleLegendItemClick.bind(this));
            }
            handleLegendItemClick(event) {
                try {
                    const $clickedItem = $(event.currentTarget);
                    const clickedItemDataSymbol = $clickedItem.attr("data-symbol");
                    if (!clickedItemDataSymbol) {
                        throw new Error("Symbol not found.");
                    }
                    const clickedItemSymbol = Number(clickedItemDataSymbol);
                    if (isNaN(clickedItemSymbol)) {
                        throw new Error("Symbol is not a number.");
                    }
                    const onClass = "selected";
                    const offClass = "not-selected";
                    const $legend = $clickedItem.closest(".chart__legend");
                    const $items = $legend.find(".chart__legend-item");
                    const $lines = $(this.containerElement).find(".chart__line");
                    const $areas = $(this.containerElement).find(".chart__area");
                    const $points = $(this.containerElement).find(".chart__point");
                    const wasSelected = $clickedItem.hasClass(onClass);
                    $clickedItem.toggleClass(onClass, !wasSelected);
                    const anyItemSelected = $items
                        .toArray()
                        .some((item) => $(item).hasClass(onClass));
                    this.symbols.forEach((dataSymbol) => {
                        const $item = $legend.find(`[data-symbol="${dataSymbol.id}"]`);
                        const symbol = Number(dataSymbol.id);
                        if (isNaN(symbol)) {
                            return;
                        }
                        const isSelected = $item.hasClass(onClass);
                        const $line = $lines.filter(`[data-symbol="${symbol}"]`);
                        const $area = $areas.filter(`[data-symbol="${symbol}"]`);
                        const $point = $points.filter(`[data-symbol="${symbol}"]`);
                        if (!anyItemSelected) {
                            $item.removeClass(offClass);
                            $line.removeClass(offClass);
                            $area.removeClass(offClass);
                            $point.removeClass(offClass);
                        }
                        else {
                            if (isSelected) {
                                $item.removeClass(offClass);
                                $line.removeClass(offClass);
                                $area.removeClass(offClass);
                                $point.removeClass(offClass);
                            }
                            else {
                                $item.addClass(offClass);
                                $line.addClass(offClass);
                                $area.addClass(offClass);
                                $point.addClass(offClass);
                            }
                        }
                    });
                }
                catch (error) {
                    console.error("Error while handling legend item click.", error);
                }
            }
            setState(newState) {
                this.state = newState;
                this.updateUI();
            }
            updateUI() {
                switch (this.state) {
                    default:
                        break;
                }
            }
            setData() {
                try {
                    if (this.data == null) {
                        throw new Error("Data not found.");
                    }
                    this.allSameOpponent = this.data.every((datapoint) => datapoint.SportEventId === this.data[0].SportEventId);
                    this.allSameStat = this.data.every((datapoint) => datapoint.StatFieldId === this.data[0].StatFieldId);
                    this.symbolIsStatFieldId = this.allSameOpponent && !this.allSameStat;
                    this.flatData = this.data
                        .map((datapoint) => {
                        if (datapoint.Value < 0) {
                            this.anyNegativeValues = true;
                        }
                        // if (!this.statFieldId && datapoint.StatFieldId) {
                        //   this.statFieldId = datapoint.StatFieldId;
                        // }
                        if (!this.statFieldIds.includes(datapoint.StatFieldId)) {
                            this.statFieldIds.push(datapoint.StatFieldId);
                        }
                        let label = this.symbolIsStatFieldId
                            ? `${datapoint.StatFieldName}`
                            : datapoint.DisplayName;
                        if (datapoint.IsSpare) {
                            label += " (S)";
                        }
                        return {
                            symbol: this.symbolIsStatFieldId
                                ? datapoint.StatFieldId.toString()
                                : datapoint.EntityBaseId.toString(),
                            label: label,
                            id: `${datapoint.StatFieldId}-${datapoint.StatDate}`,
                            date: new Date(datapoint.StatDate),
                            entityBaseId: datapoint.EntityBaseId.toString(),
                            dateId: Number(`${new Date(datapoint.StatDate).getFullYear()}-${("0" +
                                (new Date(datapoint.StatDate).getMonth() + 1)).slice(-2)}-${("0" + new Date(datapoint.StatDate).getDate()).slice(-2)}`.replace(/-/g, "")),
                            value: datapoint.Value,
                            image: "",
                            color: "",
                            areaColor: "",
                            isSpare: datapoint.IsSpare,
                            isHighlighted: datapoint.IsHighlightedMain || datapoint.IsHighlightedSecondary,
                        };
                    })
                        .sort((a, b) => {
                        return a.date.getTime() - b.date.getTime();
                    });
                    this.flatData.forEach((datapoint) => {
                        if (!this.datapointsBySymbol[datapoint.symbol]) {
                            const datapointsOfSameSymbol = this.flatData.filter((d) => {
                                return d.symbol === datapoint.symbol;
                            });
                            this.datapointsBySymbol[datapoint.symbol] =
                                datapointsOfSameSymbol !== null && datapointsOfSameSymbol !== void 0 ? datapointsOfSameSymbol : [];
                        }
                        if (!this.datapointsByDate[datapoint.dateId]) {
                            const datapointsOfSameDate = this.flatData.filter((d) => {
                                return d.dateId === datapoint.dateId;
                            });
                            this.datapointsByDate[datapoint.dateId] =
                                datapointsOfSameDate !== null && datapointsOfSameDate !== void 0 ? datapointsOfSameDate : [];
                        }
                    });
                    Object.keys(this.datapointsBySymbol).forEach((symbol, i) => {
                        this.symbols.push({
                            id: symbol,
                            name: this.datapointsBySymbol[symbol][0].label,
                            value: this.datapointsBySymbol[symbol][this.datapointsBySymbol[symbol].length - 1].value,
                            color: "",
                            areaColor: "",
                            isSpare: this.datapointsBySymbol[symbol][0].isSpare,
                        });
                    });
                    this.symbols.sort((a, b) => {
                        return b.value - a.value;
                    });
                    this.series = Object.keys(this.datapointsBySymbol).map((symbol) => {
                        return {
                            key: symbol,
                            values: this.datapointsBySymbol[symbol],
                        };
                    });
                }
                catch (error) {
                    console.error("Error while parsing data.", error);
                }
            }
            setPalette() {
                const getAreaColor = (color) => {
                    const isRGB = color.startsWith("rgb");
                    const isHEX = color.startsWith("#");
                    let opacityRGBA;
                    let opacityHEX;
                    opacityRGBA = 0.1;
                    opacityHEX = "1A";
                    if (isRGB) {
                        return color.replace("rgb", "rgba").replace(")", `, ${opacityRGBA})`);
                    }
                    else if (isHEX) {
                        return color + opacityHEX;
                    }
                    return color;
                };
                if (this.useDivergentPalette) {
                    this.palette.push(...CS.Helper.DataVisualizationHelper.getColors(this.series.length));
                    this.symbols.forEach((symbol, i) => {
                        symbol.color = this.palette[i];
                        symbol.areaColor = getAreaColor(symbol.color);
                    });
                }
                else if (this.statFieldIds.length == 1) {
                    const statFieldId = this.statFieldIds[0];
                    if (statFieldId == "EncounterOpponentsScore" ||
                        statFieldId == "Score" ||
                        statFieldId == "WinPercent") {
                        if (this.series.length == 1) {
                            this.palette.push(CS.Helper.DataVisualizationHelper.CONTINUOUS_PALETTE[500].green);
                        }
                        else {
                            this.palette.push(...CS.Helper.DataVisualizationHelper.getStatColors({
                                stat: statFieldId,
                                count: this.series.length,
                            }));
                        }
                        this;
                    }
                    else if (statFieldId == "Average") {
                        if (this.series.length == 1) {
                            this.palette.push(CS.Helper.DataVisualizationHelper.CONTINUOUS_PALETTE[500].teal);
                        }
                        else {
                            this.palette.push(...CS.Helper.DataVisualizationHelper.getStatColors({
                                stat: statFieldId,
                                count: this.series.length,
                            }));
                        }
                    }
                    else if (statFieldId == "CompuSportRating") {
                        this.palette.push(...CS.Helper.DataVisualizationHelper.getStatColors({
                            stat: statFieldId,
                            count: this.series.length,
                        }));
                    }
                    else if (statFieldId == "Differential") {
                        if (this.series.length == 1) {
                            this.palette.push(CS.Helper.DataVisualizationHelper.CONTINUOUS_PALETTE[500].indigo);
                        }
                        else {
                            this.palette.push(...CS.Helper.DataVisualizationHelper.getStatColors({
                                stat: statFieldId,
                                count: this.series.length,
                            }));
                        }
                    }
                    this.symbols.forEach((symbol, i) => {
                        symbol.color = this.palette[i];
                        symbol.areaColor = getAreaColor(symbol.color);
                    });
                }
                else if (this.statFieldIds.length > 1) {
                    for (let i = 0; i < this.statFieldIds.length; i++) {
                        const statFieldId = this.statFieldIds[i];
                        const newColor = CS.Helper.DataVisualizationHelper.getStatColors({
                            stat: statFieldId,
                            count: 1,
                        })[0];
                        this.palette.push(newColor);
                        this.symbols.forEach((symbol, i) => {
                            if (symbol.id === statFieldId) {
                                symbol.color = newColor;
                                symbol.areaColor = getAreaColor(symbol.color);
                            }
                        });
                    }
                }
                this.flatData.forEach((datapoint) => {
                    this.symbols.forEach((symbol) => {
                        if (datapoint.symbol === symbol.id) {
                            datapoint.color = symbol.color;
                            datapoint.areaColor = symbol.areaColor;
                        }
                    });
                });
                this.series.forEach((serie) => {
                    serie.values.forEach((datapoint) => {
                        this.symbols.forEach((symbol) => {
                            if (datapoint.symbol === symbol.id) {
                                datapoint.color = symbol.color;
                                datapoint.areaColor = symbol.areaColor;
                            }
                        });
                    });
                });
            }
            setChartDimensions() {
                return new Promise((resolve, reject) => {
                    try {
                        // The chart is often rendered within an accordion, which is hidden by default and animated when opened.
                        // By requesting an animation frame, we ensure that the chart is rendered after the accordion has been opened.
                        requestAnimationFrame(() => {
                            var _a, _b;
                            if (this.mode === "scroll") {
                                this.chartInnerWidth =
                                    this.chartMarginLeft +
                                        this.fontSizeX * 4 * Object.keys(this.datapointsByDate).length;
                            }
                            else {
                                this.chartInnerWidth =
                                    ((_b = (_a = this.innerContainerElement) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 1) * 1;
                            }
                            return resolve();
                        });
                    }
                    catch (error) {
                        console.error("Error while setting chart dimensions.", error);
                        return reject(error);
                    }
                });
            }
            createHTML() {
                try {
                    this.rootElement = document.body.querySelector(`#${this.id}`);
                    if (this.rootElement == null) {
                        throw new Error("Container element not found.");
                    }
                    let containerHtml = `
        <div id="line-chart-${this.id}" class="linechartv2__line-chart linechartv2__chart">
          <div id="line-chart-${this.id}-inner-container" class="linechartv2__line-chart__inner-container">
            <div id="line-chart-${this.id}-legend" class="linechartv2__line-chart__legend chart__legend"></div>
          </div>
        </div>`;
                    const containerElementExists = document.body.querySelector(`#line-chart-${this.id}`) != null;
                    if (!containerElementExists) {
                        this.rootElement.insertAdjacentHTML("beforeend", containerHtml);
                        this.containerElement = document.body.querySelector(`#line-chart-${this.id}`);
                    }
                    if (!this.innerContainerElement) {
                        this.innerContainerElement = document.body.querySelector(`#line-chart-${this.id}-inner-container`);
                    }
                    if (!this.innerContainerElement) {
                        throw new Error("Inner container element not found.");
                    }
                    if (this.containerElement == null) {
                        throw new Error("Container element not found.");
                    }
                    const innerChartContainerHtml = `<div class="linechartv2__line-chart__chart-container linechartv2__chart-container" style="position: relative; overflow: hidden;"></div>`;
                    const innerChartContainerElementExists = document.body.querySelector(`#line-chart-${this.id} .linechartv2__line-chart__chart-container`) != null;
                    if (!innerChartContainerElementExists) {
                        this.innerContainerElement.insertAdjacentHTML("beforeend", innerChartContainerHtml);
                        this.innerChartContainerElement = document.body.querySelector(`#line-chart-${this.id} .linechartv2__line-chart__chart-container`);
                    }
                    if (this.innerChartContainerElement == null) {
                        throw new Error("Inner chart container element not found.");
                    }
                    let innerChartClasses = "linechartv2__line-chart__chart";
                    if (this.mode === "scroll") {
                        innerChartClasses += " linechartv2__chart__chart--scroll";
                    }
                    const innerChartHtml = `<div class="${innerChartClasses}" style="position: relative;"></div>`;
                    const innerChartElementExists = document.body.querySelector(`#line-chart-${this.id} .linechartv2__line-chart__chart`) != null;
                    if (!innerChartElementExists) {
                        this.innerChartContainerElement.insertAdjacentHTML("beforeend", innerChartHtml);
                        this.innerChartElement = document.body.querySelector(`#line-chart-${this.id} .linechartv2__line-chart__chart`);
                    }
                    if (this.innerChartElement == null) {
                        throw new Error("Inner chart element not found.");
                    }
                    this.setLegend();
                }
                catch (error) {
                    console.error("Error while creating HTML.", error);
                }
            }
            render() {
                return new Promise((resolve, reject) => {
                    try {
                        this.setScale("x");
                        this.setScale("y");
                        if (this.xScale == null || this.yScale == null) {
                            throw new Error("Scales not found.");
                        }
                        this.setSVG();
                        this.setAxis("x");
                        this.setAxis("y");
                        if (this.area !== false) {
                            this.drawArea();
                        }
                        this.drawLines();
                        this.drawPoints();
                        this.setTooltip();
                        this.appendSVGNode();
                        if (this.mode === "scroll") {
                            this.setOverlay();
                            this.scrollChartToLeft();
                        }
                        return resolve();
                    }
                    catch (error) {
                        console.error("Error while rendering.");
                        return reject(error);
                    }
                });
            }
            unRender() {
                return new Promise((resolve, reject) => {
                    try {
                        this.removeSVG();
                        return resolve();
                    }
                    catch (error) {
                        console.error("Error while un-rendering.");
                        return reject(error);
                    }
                });
            }
            reRender() {
                return new Promise((resolve, reject) => {
                    try {
                        this.unRender()
                            .then(() => {
                            this.render()
                                .then(() => {
                                return resolve();
                            })
                                .catch((error) => {
                                console.error(error);
                                return reject(error);
                            });
                        })
                            .catch((error) => {
                            console.error(error);
                            return reject(error);
                        });
                    }
                    catch (error) {
                        console.error("Error while re-rendering.");
                        return reject(error);
                    }
                });
            }
            setLegend() {
                try {
                    const legendElement = document.body.querySelector(`#line-chart-${this.id}-legend`);
                    if (legendElement == null) {
                        throw new Error("Legend element not found.");
                    }
                    if (!this.symbols.length) {
                        throw new Error("Players not found.");
                    }
                    [...this.symbols]
                        .sort((a, b) => {
                        return b.value - a.value;
                    })
                        .forEach((symbol, index) => {
                        const rank = index + 1;
                        const opacity = symbol.isSpare ? 0.5 : 1;
                        const legendItemHtml = `
            <div class="linechartv2__line-chart__legend-item chart__legend-item" data-symbol="${symbol.id}">
              <div class="linechartv2__line-chart__legend-item__dot chart__legend-item__dot" style="background-color: ${symbol.color};"></div>
              <div class="linechartv2__line-chart__legend-item__label chart__legend-item__label" style="opacity: ${opacity};">${symbol.name}</div>
              <span>&nbsp;</span>
              <div class="linechartv2__line-chart__legend-item__value chart__legend-item__value">${this.valueFormatter(symbol.value)}</div>
              <span>&nbsp;</span>
                <div class="chart__legend-item__sub-value">(#${rank})</div>
            </div>`;
                        legendElement.insertAdjacentHTML("beforeend", legendItemHtml);
                    });
                }
                catch (error) {
                    console.error("Error while setting legend.", error);
                }
            }
            setScale(axis) {
                var _a, _b;
                try {
                    if (axis === "x") {
                        this.xScale = d3
                            .scaleUtc()
                            .domain(d3.extent(this.flatData, (d) => d.date))
                            .range([
                            this.chartMarginLeft,
                            this.chartInnerWidth - this.chartMarginRight,
                        ])
                            .clamp(true);
                    }
                    else {
                        const min = (_a = this.forcedMin) !== null && _a !== void 0 ? _a : (d3.min(this.flatData, (d) => d.value) || 0);
                        const max = (_b = this.forcedMax) !== null && _b !== void 0 ? _b : (d3.max(this.flatData, (d) => d.value) || 0);
                        this.yScale = d3
                            .scaleLinear([min, max], [
                            this.chartInnerHeight - this.chartMarginBottom,
                            this.chartMarginTop,
                        ])
                            .nice();
                    }
                }
                catch (error) {
                    console.error(`Error while creating ${axis}-scale.`, error);
                }
            }
            setSVG() {
                try {
                    this.svg = d3
                        .create("svg")
                        .attr("viewBox", [0, 0, this.chartInnerWidth, this.chartInnerHeight])
                        .attr("width", this.chartInnerWidth)
                        .attr("height", this.chartInnerHeight > 0 ? this.chartInnerHeight : 1)
                        .attr("class", "chart__svg")
                        .style("-webkit-tap-highlight-color", "transparent")
                        .style("overflow", "visible");
                    if (this.mode === "scroll") {
                        this.svgOverlay = d3
                            .create("svg")
                            .attr("viewBox", [
                            0,
                            0,
                            this.chartInnerWidth,
                            this.chartInnerHeight,
                        ])
                            .attr("width", this.chartInnerWidth)
                            .attr("height", this.chartInnerHeight > 0 ? this.chartInnerHeight : 1)
                            .attr("class", "chart__svg-overlay")
                            .style("-webkit-tap-highlight-color", "transparent")
                            .style("overflow", "visible");
                    }
                    if (this.isMobile) {
                        this.svg
                            .on("pointerenter pointermove", this.onPointerMove.bind(this))
                            .on("pointerleave", this.onPointerLeave.bind(this));
                        // .on("touchstart", this.onPointerMove.bind(this));
                        // .on("touchmove", this.onPointerMove.bind(this))
                        // .on("touchend", this.onPointerLeave.bind(this));
                    }
                    else {
                        this.svg
                            .on("pointerenter pointermove", this.onPointerMove.bind(this))
                            .on("pointerleave", this.onPointerLeave.bind(this));
                    }
                }
                catch (error) {
                    console.error("Error while creating SVG container.", error);
                }
            }
            removeSVG() {
                try {
                    if (this.innerChartElement == null) {
                        throw new Error("Inner chart element not found.");
                    }
                    const svg = this.innerChartElement.querySelector("svg");
                    if (svg != null) {
                        this.innerChartElement.removeChild(svg);
                    }
                }
                catch (error) {
                    console.error("Error while removing SVG.", error);
                }
            }
            setAxis(axis) {
                var _a, _b, _c, _d, _e;
                try {
                    if (this.xScale == null || this.yScale == null) {
                        throw new Error("Scales not found.");
                    }
                    if (axis === "x") {
                        const lang = (_b = (_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.Language) !== null && _b !== void 0 ? _b : "en";
                        (_c = this.svg) === null || _c === void 0 ? void 0 : _c.append("g").attr("transform", `translate(0,${this.chartInnerHeight - this.chartMarginBottom})`).call(d3
                            .axisBottom(this.xScale)
                            .ticks(this.chartInnerWidth / 80)
                            .tickSizeOuter(0)
                            .tickFormat((d, index) => {
                            if (!(d instanceof Date)) {
                                return "";
                            }
                            return d.toLocaleDateString(lang, {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                            });
                            // return d3.timeFormat("%b %d, %Y")(d);
                        })).call((g) => g.select(".domain").attr("class", "domain--x")).call((g) => g
                            .selectAll(".tick line")
                            .clone()
                            .attr("y2", -this.chartInnerHeight +
                            this.chartMarginBottom +
                            this.chartMarginTop)
                            .attr("stroke-opacity", 0.05)).call((g) => g
                            .selectAll(".tick")
                            .attr("class", (d) => `tick--x tick--x-${d.toString().replace(".", "-")}`)).selectAll("text").attr("transform", "translate(-13,5)rotate(-60)").attr("font-size", this.fontSizeX).attr("fill", this.textColorX).style("text-anchor", "end");
                    }
                    if (axis === "y") {
                        const yAxisOpacity = this.mode === "scroll" ? 0 : 1;
                        (_d = this.svg) === null || _d === void 0 ? void 0 : _d.append("g").style("opacity", yAxisOpacity).attr("transform", `translate(${this.chartMarginLeft},0)`).call(d3
                            .axisLeft(this.yScale)
                            .ticks(this.chartInnerHeight / 60)
                            .tickFormat((d, index) => {
                            return this.valueFormatter(d.valueOf());
                        })).call((g) => g.select(".domain").attr("class", "domain--y")).call((g) => g
                            .selectAll(".tick line")
                            .clone()
                            .attr("x2", this.chartInnerWidth -
                            this.chartMarginLeft -
                            this.chartMarginRight)
                            .attr("stroke-opacity", 0.05)).call((g) => g
                            .selectAll(".tick")
                            .attr("class", (d) => `tick--y tick--y-${d.toString().replace(".", "-")}`)).selectAll("text").attr("font-size", this.fontSizeY).attr("fill", this.textColorY);
                        if (this.mode === "static") {
                            this.svg
                                .select(".domain--x")
                                .attr("fill", "none")
                                .attr("stroke", this.domainLineColor);
                            this.svg
                                .selectAll(".tick--x line")
                                .attr("stroke", this.domainLineColor);
                            this.svg
                                .select(".domain--y")
                                .attr("fill", "none")
                                .attr("stroke", this.domainLineColor);
                            this.svg
                                .selectAll(".tick--y line")
                                .attr("stroke", this.domainLineColor);
                        }
                        if (this.mode === "scroll") {
                            (_e = this.svgOverlay) === null || _e === void 0 ? void 0 : _e.style("position", "absolute").style("top", "0").style("left", "0").style("pointer-events", "none").style("z-index", "1").append("g").attr("transform", `translate(${this.chartMarginLeft},0)`).call(d3
                                .axisLeft(this.yScale)
                                .ticks(this.chartInnerHeight / 60)
                                .tickFormat((d, index) => {
                                return this.valueFormatter(d.valueOf());
                            })).call((g) => g
                                .selectAll(".tick line")
                                .clone()
                                .attr("x2", this.chartInnerWidth -
                                this.chartMarginLeft -
                                this.chartMarginRight)
                                .attr("stroke-opacity", 0.05)).selectAll("text").attr("font-size", this.fontSizeY).attr("fill", this.textColorY);
                        }
                    }
                }
                catch (error) {
                    console.error(`Error while adding ${axis}-axis.`, error);
                }
            }
            drawLines() {
                var _a, _b, _c;
                try {
                    if (this.xScale == null || this.yScale == null) {
                        throw new Error("Scales not found.");
                    }
                    this.serie =
                        (_b = (_a = this.svg) === null || _a === void 0 ? void 0 : _a.append("g").selectAll("g").data(this.series).join("g")) !== null && _b !== void 0 ? _b : null;
                    const line = d3
                        .line()
                        .defined((d) => { var _a; return !isNaN((_a = d.value) !== null && _a !== void 0 ? _a : NaN); }) // Some values aren't available for some dates.
                        .x((d) => { var _a, _b; return (_b = (_a = this.xScale) === null || _a === void 0 ? void 0 : _a.call(this, d.date.getTime())) !== null && _b !== void 0 ? _b : -1; })
                        .y((d) => { var _a, _b, _c; return (_c = (_a = this.yScale) === null || _a === void 0 ? void 0 : _a.call(this, (_b = d.value) !== null && _b !== void 0 ? _b : NaN)) !== null && _c !== void 0 ? _c : -1; });
                    (_c = this.serie) === null || _c === void 0 ? void 0 : _c.append("path").attr("fill", "none").attr("stroke-linejoin", "round").attr("stroke-linecap", "round").attr("stroke-width", (d) => {
                        return d.values.length
                            ? d.values[0].isSpare
                                ? this.strokeWidth / 2
                                : this.strokeWidth
                            : this.strokeWidth;
                    }).attr("class", (d) => {
                        return `linechartv2__line-chart__line linechartv2__line-chart__line--${d.key} chart__line chart__line--${d.key}`;
                    }).attr("data-symbol", (d) => {
                        return d.key;
                    }).attr("stroke", (d) => {
                        return d.values.length ? d.values[0].color : "white";
                    }).attr("d", (d) => {
                        return line(d.values.filter((d) => { var _a; return !isNaN((_a = d.value) !== null && _a !== void 0 ? _a : NaN) && d.value !== null; }));
                    });
                }
                catch (error) {
                    console.error("Error while drawing lines.", error);
                }
            }
            drawPoints() {
                var _a;
                try {
                    // Add a point for each defined value.
                    (_a = this.serie) === null || _a === void 0 ? void 0 : _a.append("g").attr("stroke-linecap", "round").attr("stroke-linejoin", "round").attr("text-anchor", "middle").selectAll().data((d) => {
                        return d.values.filter((datapoint) => {
                            var _a;
                            return isNaN((_a = datapoint.value) !== null && _a !== void 0 ? _a : NaN) === false;
                        });
                    }).join("circle").attr("r", (d, i) => {
                        if (d.isSpare) {
                            return this.pointRadius / 1.5;
                        }
                        return this.pointRadius;
                    }).attr("fill", (d, i) => {
                        return d.color;
                    }).attr("opacity", (d, i) => {
                        return 1;
                    }).attr("cx", (d) => {
                        if (this.xScale == null) {
                            return 0;
                        }
                        return this.xScale(d.date);
                    }).attr("cy", (d) => {
                        if (this.yScale == null) {
                            return 0;
                        }
                        return this.yScale(d.value);
                    }).attr("class", (d) => {
                        return `linechartv2__line-chart__point linechartv2__line-chart__point--${d.symbol} chart__point chart__point--${d.symbol}`;
                    }).attr("data-symbol", (d) => {
                        return d.symbol;
                    });
                }
                catch (error) {
                    console.error("Error while drawing circles.", error);
                }
            }
            drawArea() {
                var _a;
                try {
                    if (this.xScale == null || this.yScale == null) {
                        throw new Error("Scales not found.");
                    }
                    const area = d3
                        .area()
                        .defined((d) => { var _a; return !isNaN((_a = d.value) !== null && _a !== void 0 ? _a : NaN); })
                        .x((d) => { var _a, _b; return ((_b = (_a = this.xScale) === null || _a === void 0 ? void 0 : _a.call(this, d.date.getTime())) !== null && _b !== void 0 ? _b : -1); })
                        .y0(this.anyNegativeValues
                        ? (_a = this.yScale) === null || _a === void 0 ? void 0 : _a.call(this, 0)
                        : this.chartInnerHeight - this.chartMarginBottom)
                        .y1((d) => { var _a; return (_a = this.yScale) === null || _a === void 0 ? void 0 : _a.call(this, d.value); });
                    let series = this.series;
                    if (Array.isArray(this.area)) {
                        series = this.series.filter((serie) => {
                            return this.area.includes(serie.key);
                        });
                    }
                    series.forEach((serie, i) => {
                        var _a;
                        (_a = this.svg) === null || _a === void 0 ? void 0 : _a.append("path").attr("class", "area").attr("class", (d) => {
                            return `linechartv2__line-chart__area linechartv2__line-chart__area--${serie.key} chart__area chart__area--${serie.key}`;
                        }).attr("data-symbol", (d) => {
                            return serie.key;
                        }).attr("fill", () => {
                            return serie.values.length ? serie.values[0].areaColor : "white";
                        }).attr("d", area(serie.values));
                    });
                }
                catch (error) {
                    console.error("Error while drawing area.", error);
                }
            }
            setTooltip() {
                var _a;
                try {
                    const tooltipV2HTML = document.createElement("div");
                    tooltipV2HTML.setAttribute("class", "linechartv2__tooltip-v2");
                    (_a = this.innerChartContainerElement) === null || _a === void 0 ? void 0 : _a.appendChild(tooltipV2HTML);
                    this.tooltipV2 = d3.select(tooltipV2HTML);
                }
                catch (error) {
                    console.error("Error while adding tooltip.", error);
                }
            }
            appendSVGNode() {
                var _a, _b;
                try {
                    const svgNode = (_a = this.svg) === null || _a === void 0 ? void 0 : _a.node();
                    if (!(svgNode instanceof SVGSVGElement)) {
                        throw new Error("SVG node not found.");
                    }
                    if (!this.innerChartElement) {
                        throw new Error("Inner chart element not found.");
                    }
                    if (!this.innerChartContainerElement) {
                        throw new Error("Inner chart container element not found.");
                    }
                    this.innerChartElement.appendChild(svgNode);
                    if (this.mode === "scroll") {
                        const svgOverlayNode = (_b = this.svgOverlay) === null || _b === void 0 ? void 0 : _b.node();
                        if (!(svgOverlayNode instanceof SVGSVGElement)) {
                            throw new Error("SVG overlay node not found.");
                        }
                        this.innerChartContainerElement.appendChild(svgOverlayNode);
                    }
                }
                catch (error) {
                    console.error("Error while appending SVG node.", error);
                }
            }
            setOverlay() {
                var _a, _b, _c;
                try {
                    if (!this.innerChartContainerElement) {
                        throw new Error("Inner chart element not found.");
                    }
                    const overlayHTML = `<div class="linechartv2__chart__overlay"></div>`;
                    const overlayElementExists = document.body.querySelector(`#line-chart-${this.id} .linechartv2__chart__overlay`) != null;
                    if (!overlayElementExists) {
                        this.innerChartContainerElement.insertAdjacentHTML("beforeend", overlayHTML);
                        this.chartOverlayElement = document.body.querySelector(`#line-chart-${this.id} .linechartv2__chart__overlay`);
                    }
                    if (this.chartOverlayElement == null) {
                        throw new Error("Chart overlay element not found.");
                    }
                    if (!this.chartOverlayElement) {
                        throw new Error("Chart overlay element not found.");
                    }
                    this.chartOverlayElement.style.width = `${this.chartMarginLeft}px`;
                    this.chartOverlayElement.style.height = `${this.chartInnerHeight}px`;
                    this.chartOverlayElement.style.pointerEvents = "none";
                    // Get computed style property background color
                    const backgroundColor = (_c = (_b = (_a = this.containerElement) === null || _a === void 0 ? void 0 : _a.computedStyleMap().get("background-color")) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : "";
                    if (!backgroundColor) {
                        throw new Error("Background color not found.");
                    }
                    this.chartOverlayElement.style.backgroundColor = backgroundColor;
                }
                catch (error) {
                    console.error("Error while setting overlay width.", error);
                }
            }
            scrollChartToLeft() {
                try {
                    if (!this.innerChartContainerElement) {
                        throw new Error("Inner chart container element not found.");
                    }
                    this.innerChartContainerElement.scrollLeft =
                        this.innerChartContainerElement.scrollWidth;
                }
                catch (error) {
                    console.error("Error while scrolling chart to right.", error);
                }
            }
            onPointerMove(event) {
                try {
                    if (this.state !== "ready") {
                        return;
                    }
                    if (!this.svg || !this.xScale) {
                        throw new Error("SVG or xScale not found.");
                    }
                    const date = this.xScale.invert(d3.pointer(event, this.svg.node())[0]);
                    const closestDatapoint = this.flatData.reduce((prev, curr) => {
                        return Math.abs(curr.date.getTime() - date.getTime()) <
                            Math.abs(prev.date.getTime() - date.getTime())
                            ? curr
                            : prev;
                    });
                    if (!closestDatapoint) {
                        return;
                    }
                    const datapointsOfDate = this.flatData
                        .filter((datapoint) => {
                        return datapoint.dateId == closestDatapoint.dateId;
                    })
                        .sort((a, b) => {
                        return b.value - a.value;
                    });
                    this.drawTooltip(closestDatapoint, datapointsOfDate, event);
                    this.highlightDatapoints(datapointsOfDate);
                }
                catch (error) {
                    console.error("Error while handling pointer move.", error);
                }
            }
            drawTooltip(closestDatapoint, datapointsOfDate, event) {
                var _a, _b, _c, _d, _e, _f;
                if (!this.tooltipV2) {
                    throw new Error("Tooltip not found.");
                }
                const lang = (_b = (_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.Language) !== null && _b !== void 0 ? _b : "en";
                this.tooltipV2
                    .style("opacity", 1)
                    .attr("class", "linechartv2__tooltip-v2").html(`
        <div class="linechartv2__tooltip-v2__title">${closestDatapoint.date.toLocaleDateString(lang, {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                })}</div>
        <div class="linechartv2__tooltip-v2__content">
        ${datapointsOfDate
                    .map((d) => {
                    const symbol = this.symbols.find((symbol) => {
                        return symbol.id === d.symbol;
                    });
                    if (!symbol) {
                        return "";
                    }
                    const color = symbol.color;
                    return `<div class="linechartv2__tooltip-v2__content__item">
            <div class="linechartv2__tooltip-v2__content__item__color" style="background-color: ${color};"></div>
            <div class="linechartv2__tooltip-v2__content__item__label">${d.label}</div>
            <div class="linechartv2__tooltip-v2__content__item__value">${this.valueFormatter(d.value)}</div>
            </div>`;
                })
                    .join("")}
          </div>
          `);
                const tooltipOuterWidth = (_d = (_c = this.tooltipV2.node()) === null || _c === void 0 ? void 0 : _c.clientWidth) !== null && _d !== void 0 ? _d : 0;
                const pointerXPos = d3.pointer(event, this.innerChartContainerElement)[0];
                const chartClientWidth = (_f = (_e = this.innerChartContainerElement) === null || _e === void 0 ? void 0 : _e.clientWidth) !== null && _f !== void 0 ? _f : 1;
                const isOnLeftSide = pointerXPos < chartClientWidth / 2;
                const tooltipXPos = isOnLeftSide
                    ? pointerXPos + 20
                    : pointerXPos - tooltipOuterWidth - 20;
                this.tooltipV2.style("left", `${tooltipXPos}px`);
            }
            highlightDatapoints(datapointsOfDate) {
                try {
                    if (!this.svg) {
                        throw new Error("SVG not found.");
                    }
                    this.svg
                        .selectAll(".linechartv2__line-chart__point")
                        .attr("opacity", (d) => {
                        const datapoint = d;
                        return datapointsOfDate.includes(datapoint) ? 1 : 0.5;
                    })
                        .attr("r", (d) => {
                        const datapoint = d;
                        return datapointsOfDate.includes(datapoint)
                            ? this.mode === "scroll"
                                ? this.pointRadius * 1.5
                                : this.pointRadius * 3
                            : this.pointRadius * (this.isMobile ? 0 : 1);
                    });
                }
                catch (error) {
                    console.error("Error while highlighting datapoints.", error);
                }
            }
            resetHighlightedDatapoints() {
                try {
                    if (!this.svg) {
                        throw new Error("SVG not found.");
                    }
                    this.svg
                        .selectAll(".linechartv2__line-chart__point")
                        .attr("opacity", 1)
                        .attr("r", (d) => {
                        return d.isSpare ? this.pointRadius / 1.5 : this.pointRadius;
                    });
                }
                catch (error) {
                    console.error("Error while resetting highlighted datapoints.", error);
                }
            }
            onPointerLeave(event) {
                try {
                    if (this.state !== "ready") {
                        return;
                    }
                    this.hideTooltip();
                    this.resetHighlightedDatapoints();
                }
                catch (error) {
                    console.error("Error while handling pointer leave.", error);
                }
            }
            hideTooltip() {
                if (!this.tooltipV2) {
                    throw new Error("Tooltip not found.");
                }
                this.tooltipV2.style("opacity", 0);
            }
        }
        Controls.LineChart = LineChart;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=LineChart.js.map
